import { useSelector, useDispatch } from "react-redux"
import { Tooltip } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { useEffect } from "react"
import { obtenerNotificacionesPaquete } from "../../../ducks/clientesDuck"
import { FormatoFechaIso } from "../../../utils/FormatFecha"
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

const VNotificaciones = () => {
    const { notificaciones, cliente } = useSelector(store => store.cliente)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(obtenerNotificacionesPaquete({ idPaquete: cliente?.paquete?.Id_Paquete }))
    }, [dispatch, cliente?.paquete?.Id_Paquete])

    const classes = useStyles();
    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center">#</TableCell>
                        <TableCell align="center">Fecha</TableCell>
                        <TableCell align="center">Descripción</TableCell>
                        <TableCell align="center">App</TableCell>
                        <TableCell align="center">SMS</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {notificaciones.map((row, index) => (
                        <TableRow key={index + 1}>
                            <TableCell align="center" component="th" scope="row">
                                {index + 1}
                            </TableCell>
                            <TableCell align="center">{FormatoFechaIso({ date: row?.FechaRegistro })}</TableCell>
                            <TableCell align="center">{row.Descripcion}</TableCell>
                            <TableCell align="center">
                                {
                                    (row?.EnvioDispositivo) &&
                                    <Tooltip title="Enviada">
                                        <CheckCircleIcon color='secondary' />
                                    </Tooltip>
                                }
                            </TableCell>
                            <TableCell align="center">
                                {
                                    (row?.EnvioTwilio) &&
                                    <Tooltip title="Enviada">
                                        <CheckCircleIcon color='secondary' />
                                    </Tooltip>
                                }
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
export default VNotificaciones